import { useState, useEffect, useRef } from "react";

import context from "./context";
import API_ENDPOINT from "../config";

const TendersContextProvider = (props) => {
  const telegramTenderPage =
    window.location.pathname.startsWith("/latest-tenders/telegram") ||
    window.location.pathname.startsWith("/myfeed/telegram");
  const telegramDetailPage =
    window.location.pathname.startsWith("/tender/telegram");

  const [telegramTenderId, setTelegramTenderId] = useState(null);
  const [telegramUserNumber, setTelegramUserNumber] = useState(null);

  const userToken = localStorage.getItem("token");

  const [selectedPlan, setSelectedPlan] = useState("");

  const [token, setToken] = useState(userToken || "");

  const [popularCompanies, setPopularCompanies] = useState([]);

  const [finishedRegistration, setFinishedRegistration] = useState(false);

  const [showSearchDarwer, setShowSearchDrawer] = useState(false);

  const [popularCategories, setPopularCategories] = useState([]);

  const [tendersPopularCategories, setTendersPopularCategories] = useState([]);

  const [searchIsClicked, setSearchIsClicked] = useState(false);

  const showDrawerHandler = () => {
    setShowSearchDrawer((prev) => {
      return !prev;
    });
  };

  // TENDER DETAILS  ////////////////////////////////////////////////////////////////////////////

  const [showTenderDetail, setShowTenderDetail] = useState(false);
  const [prevRoute, setPrevRoute] = useState(
    telegramTenderPage || telegramDetailPage
      ? "/latest-tenders/telegram"
      : "/tenders"
  );

  const [scrollCoordinates, setScrollCoordinates] = useState(0);

  /////// FETCH TENDERS //////////////////////////////////////////////////////////////////////

  const [tenders, setTenders] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isFetchingTenders, setIsFetchingTenders] = useState(false);
  const [scrollCount, setScrollCount] = useState(1);
  const [fetchLimiter, setFetchLimiter] = useState(null);
  const [apiPath, setApiPath] = useState("");
  const [telegramApiPath, setTelegramApiPath] = useState("");
  const [searchParams, setSearchParams] = useState({
    title: "",
    categoryId: "",
    regionId: "",
    languageId: "",
    startDate: "",
    endDate: "",
    status: "",
    page: "",
    companyId: "",
    tenderSrc: "",
  });

  const shouldLoadTendersRef = useRef(true);

  const setShouldLoadTenders = (value) => {
    shouldLoadTendersRef.current = value;
  };

  useEffect(() => {
    setSelectedCategory("");

    if (!window.location.pathname.startsWith("/company/")) {
      setSearchParams({
        title: "",
        categoryId: "",
        regionId: "",
        languageId: "",
        startDate: "",
        endDate: "",
        status: "",
        page: "",
        companyId: "",
        tenderSrc: "",
      });
    }
  }, [apiPath]);

  useEffect(() => {
    setScrollCount(1);
    setTenders([]);
  }, [selectedCategory, apiPath, telegramApiPath]);

  // fetching

  const fetchData = () => {
    let auth_data;

    const onTelegram =
      telegramTenderPage ||
      telegramDetailPage ||
      window.location.pathname.includes("/telegram");
    if (onTelegram) {
      auth_data = encodeURIComponent(window.Telegram?.WebApp?.initData || "");
    }
    setIsFetchingTenders(true);
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token}`);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: headers,
    };
    const useTelegramListApi =
      telegramApiPath === "latest-tenders" || telegramApiPath === "myfeed";

    fetch(
      useTelegramListApi
        ? `${API_ENDPOINT}/telegram/${telegramApiPath}?data_check_string=${auth_data}&page=${scrollCount}&title=${searchParams.title}&category_id=${searchParams.categoryId}&region_id=${searchParams.regionId}&language_id=${searchParams.languageId}&start_date=${searchParams.startDate}&end_date=${searchParams.endDate}&status_id=${searchParams.status}&source_id=${searchParams.tenderSrc}`
        : `${API_ENDPOINT}/${apiPath}?title=${searchParams.title}&category_id=${searchParams.categoryId}&region_id=${searchParams.regionId}&language_id=${searchParams.languageId}&start_date=${searchParams.startDate}&end_date=${searchParams.endDate}&status_id=${searchParams.status}&page=${scrollCount}&company_id=${searchParams.companyId}&source_id=${searchParams.tenderSrc}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 401 && !telegramTenderPage && !telegramDetailPage) {
          localStorage.clear();
          window.location.href = "/login";
        }

        return response.json();
      })
      .then((result) => {
        //case to be removed
        if (result.status === true) {
          setFetchLimiter(result.tenders.next_page_url);

          if (scrollCount === 1) {
            setTenders(result.tenders.data);
          } else {
            setTenders((prevTenders) => [
              ...prevTenders,
              ...result.tenders.data,
            ]);
          }
        }
        setIsFetchingTenders(false);
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (
      (apiPath !== "" && shouldLoadTendersRef.current) ||
      (tenders.length === 0 && apiPath !== "") ||
      telegramTenderPage
    ) {
      let timer;
      setIsFetchingTenders(true);

      const debounceFetchData = () => {
        clearTimeout(timer);
        timer = setTimeout(fetchData, 500);
      };

      debounceFetchData();

      return () => {
        clearTimeout(timer);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, scrollCount, apiPath, telegramApiPath]);

  // GET POPULAR CATEGORIES /////////////////////////////////////////////////////////////////////

  const [getingPopularCategories, setGetingPopularCategories] = useState(false);

  const popularCategoriesRef = useRef([0]);

  const setPopularCategoriesRef = (value) => {
    popularCategoriesRef.current = value;
  };

  const getPopularCategories = (path) => {
    setGetingPopularCategories(true);
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token || userToken}`);

    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: headers,
    };

    fetch(
      `${API_ENDPOINT}/tender/popular/categories?path=${path}`,
      requestOptions
    )
      .then((response) => {
        if (
          response.status === 401 &&
          !window.location.pathname.includes("/telegram")
        ) {
          localStorage.clear();
          window.location.href = "/login";
        }
        return response.json();
      })
      .then((result) => {
        setGetingPopularCategories(false);

        if (path === "") {
          setTendersPopularCategories(result);
        } else {
          setPopularCategories(result);
          setPopularCategoriesRef(result);
        }
      })
      .catch((error) => {
        setGetingPopularCategories(false);
        console.log("error", error);
      });
  };

  // SEARCHING FILTER ///////////////////////////////////////////////////////////////////////////

  const [categoryLists, setCategoryLists] = useState([]);
  const [regions, setRegions] = useState([]);
  const [language, setLanguage] = useState([]);

  const [feedCategoryLists, setFeedCategoryLists] = useState([]);
  const [feedRegions, setFeedRegions] = useState([]);
  const [feedLanguage, setFeedLanguage] = useState([]);

  const [isFetchingLangAndReg, setIsFetchingLangAndReg] = useState(false);
  const [isFetchingFeedCategories, setIsFetchingFeedCategories] =
    useState(false);
  const [isFetchingSrc, setIsFetchingSrc] = useState(false);

  const [tendersCategoryLists, setTendersCategoryLists] = useState([]);
  const [tendersRegions, setTendersRegions] = useState([]);
  const [tendersLanguage, setTendersLanguage] = useState([]);
  const [tendersSrc, setTendersSrc] = useState([]);

  const [searchingTitle, setSearchingTitle] = useState("");
  const [searchingRegionId, setSearchingRegionId] = useState("");
  const [searchingLanguageId, setSearchingLanguageId] = useState("");
  const [searchingCategoryId, setSearchingCategoryId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchingSrc, setSearchingSrc] = useState("");

  const SearchTenders = () => {
    setSearchParams({
      ...searchParams,
      title: searchingTitle,
      categoryId: searchingCategoryId,
      regionId: searchingRegionId,
      languageId: searchingLanguageId,
      status: selectedStatus,
      tenderSrc: searchingSrc,
    });
    setScrollCount(1);
    setTenders([]);
    setSearchIsClicked(true);
    showDrawerHandler();
  };

  // SAVE COUNT /////////////////////////////////////////////////////////////////////////////////

  const [savedCount, setSavedCount] = useState(0);
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    company_name: "",
    tin: "",
  });

  const [isVerified, setIsVerified] = useState({
    phone: true,
    email: true,
  });

  const getUserData = () => {
    setSavedCount(0);
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token || userToken}`);

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(`${API_ENDPOINT}/client/user-info`, requestOptions)
      .then((response) => {
        if (
          response.status === 401 &&
          !window.location.pathname.includes("/telegram")
        ) {
          localStorage.clear();
          window.location.href = "/login";
        }

        return response.json();
      })
      .then((result) => {
        setSavedCount(result.unseen_tender_count);
        setUserInfo(result);
        setIsVerified({
          phone: result.is_phone_verified,
          email: result.is_email_verified,
        });
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (token) {
      getUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const onTelegram = window.location.pathname.includes("/telegram");
    if (!onTelegram || token) {
      return;
    }
    const auth_data = encodeURIComponent(window.Telegram?.WebApp?.initData || "");
    if (!auth_data) {
      return;
    }

    fetch(`${API_ENDPOINT}/telegram/me?data_check_string=${auth_data}`)
      .then((response) => response.json())
      .then((result) => {
        if (result.token) {
          localStorage.setItem("token", result.token);
          setToken(result.token);
        }
        if (result.name) {
          setUserInfo(result);
          setSavedCount(result.unseen_tender_count || 0);
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ALERT STATUS //////////////////////////////////////////////////////////////////////////////

  const [channels, setChannels] = useState({
    email: "",
    sms: "",
    telegram: "",
  });

  const getAlertStatus = () => {
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token || userToken}`);

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(`${API_ENDPOINT}/client/setting/get-channel`, requestOptions)
      .then((response) => {
        if (
          response.status === 401 &&
          !window.location.pathname.includes("/telegram")
        ) {
          localStorage.clear();
          window.location.href = "/login";
        }
        return response.json();
      })
      .then((result) => {
        setChannels({
          email: result.channels.email ? 1 : 0,
          sms: result.channels.sms ? 1 : 0,
          telegram: result.channels.telegram ? 1 : 0,
        });
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (token) {
      getAlertStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // BOTTOM NAVIGATION //////////////////////////////////////////////////////////////////////////

  const [clickedBtn, setClickedBtn] = useState("");
  const currentPath = document.location.pathname;
  useEffect(() => {
    let btnId = "";
    if (currentPath === "/tenders") {
      btnId = "Btn1";
    } else if (currentPath === "/myfeed") {
      btnId = "Btn2";
    } else if (currentPath === "/saved") {
      btnId = "Btn3";
    }

    setClickedBtn(btnId);
  }, [currentPath]);

  // COMPANY DETAIL /////////////////////////////////////////////////////////////////////////////

  const [companyDetail, setCompanyDetail] = useState(null);

  // ////////////////////////////////////////////////////////////////////////////////////////////
  const [preferance, setPreferance] = useState(false);

  const getCategories = (filter) => {
    if (filter === "myfeed") {
      setIsFetchingFeedCategories(true);
    }

    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token || userToken}`);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: headers,
    };

    fetch(`${API_ENDPOINT}/tender/categories?path=${filter}`, requestOptions)
      .then((response) => {
        if (
          response.status === 401 &&
          !window.location.pathname.includes("/telegram")
        ) {
          localStorage.clear();
          window.location.href = "/login";
        }
        return response.json();
      })
      .then((result) => {
        if (filter === "") {
          setTendersCategoryLists(result);
        } else if (filter === "myfeed") {
          setFeedCategoryLists(result);
          setIsFetchingFeedCategories(false);
          result.length !== 0 ? setPreferance(false) : setPreferance(true);
        } else {
          setCategoryLists(result);
        }
      })
      .catch((error) => {
        setIsFetchingFeedCategories(false);
        console.log("error", error);
      });
  };

  const getLanguagesAndRegions = (filter) => {
    setIsFetchingLangAndReg(true);
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token || userToken}`);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: headers,
    };

    fetch(`${API_ENDPOINT}/tender/lang-reg?path=${filter}`, requestOptions)
      .then((response) => {
        if (
          response.status === 401 &&
          !window.location.pathname.includes("/telegram")
        ) {
          localStorage.clear();
          window.location.href = "/login";
        }
        return response.json();
      })
      .then((result) => {
        if (filter === "") {
          setTendersLanguage(result.languages);
          setTendersRegions(result.regions);
        } else if (filter === "myfeed") {
          setIsFetchingLangAndReg(false);
          setFeedLanguage(result.languages);
          setFeedRegions(result.regions);
          result.languages.length !== 0 || result.regions.length !== 0
            ? setPreferance(false)
            : setPreferance(true);
        } else {
          setLanguage(result.languages);
          setRegions(result.regions);
        }
      })
      .catch((error) => {
        setIsFetchingLangAndReg(false);
        console.log("error", error);
      });
  };

  const getSrc = () => {
    setIsFetchingSrc(true);
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${token || userToken}`);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: headers,
    };

    fetch(`${API_ENDPOINT}/tender/sources`, requestOptions)
      .then((response) => {
        if (
          response.status === 401 &&
          !window.location.pathname.includes("/telegram")
        ) {
          localStorage.clear();
          window.location.href = "/login";
        }
        return response.json();
      })
      .then((result) => {
        setIsFetchingSrc(false);
        setTendersSrc(result);
      })
      .catch((error) => {
        setIsFetchingSrc(false);
        console.log("error", error);
      });
  };
  // Verification ////////////////////////////////////////////////////////////////////////////////
  const [verificationOtpIsSending, setVerificationOtpIsSending] =
    useState(false);
  const VerifyContact = (path, func) => {
    setVerificationOtpIsSending(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `"Bearer ${userToken}`);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${API_ENDPOINT}/auth/send-OTP?${path}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        func && func();

        setVerificationOtpIsSending(false);
      })
      .catch((error) => {
        setVerificationOtpIsSending(false);
        console.log("error", error);
      });
  };

  // SUBSCRIPTION //////////////////////////////////////////////////////////////////////////////

  const [isFetchingInvoice, setIsFetchingInvoice] = useState(false);

  const HandleSubscription = (func = null) => {
    const telegramInitData =
      window.Telegram?.WebApp?.initData &&
      (window.location.pathname.startsWith("/tender/telegram") ||
        window.location.pathname.startsWith("/latest-tenders/telegram") ||
        window.location.pathname.startsWith("/myfeed/telegram") ||
        window.location.pathname.startsWith("/signup/telegram") ||
        window.location.pathname.startsWith("/login/telegram"))
        ? encodeURIComponent(window.Telegram.WebApp.initData)
        : "";

    if (userToken || telegramInitData) {
      setIsFetchingInvoice(true);
      var myHeaders = new Headers();
      if (userToken) {
        myHeaders.append("Authorization", `Bearer ${userToken}`);
      }

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const checkoutUrl =
        telegramInitData && !userToken
          ? `${API_ENDPOINT}/chapa/create-url?data_check_string=${telegramInitData}`
          : `${API_ENDPOINT}/chapa/create-url`;

      fetch(checkoutUrl, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setIsFetchingInvoice(false);
          if (result.token) {
            localStorage.setItem("token", result.token);
            setToken(result.token);
          }
          if (result.url) {
            if (telegramInitData) {
              sessionStorage.setItem("telegram_checkout_url", result.url);
              sessionStorage.setItem(
                "telegram_checkout_return",
                window.location.pathname + window.location.search
              );
              window.location.assign("/telegram/checkout");
            } else {
              window.location.href = result.url;
            }
          } else if (telegramInitData && window.Telegram?.WebApp?.showPopup) {
            window.Telegram.WebApp.showPopup({
              title: "Payment failed",
              message:
                result.message ||
                "Could not start payment. Please try again.",
              buttons: [{ type: "close", text: "Close" }],
            });
          }
          console.log(result);
        })
        .catch((error) => {
          setIsFetchingInvoice(false);
          console.log("error", error);
        });
    } else {
      if (func) {
        func();
      }
    }
  };
  // VALUES /////////////////////////////////////////////////////////////////////////////////////

  const value = {
    isVerified,
    setIsVerified,
    userInfo,
    setUserInfo,
    selectedPrice: selectedPlan,
    setSelectedPlan,
    token: token,
    setToken,
    finishedRegistration,
    setFinishedRegistration,
    popularCompanies: popularCompanies,
    setPopularCompanies,
    showSearchDarwer,
    setShowSearchDrawer,
    showDrawerHandler,
    popularCategories,
    setPopularCategories,
    tendersPopularCategories,
    setTendersPopularCategories,

    //popular Categories
    getPopularCategories,
    getingPopularCategories,
    popularCategoriesRef,

    // tenders fetching
    fetchData,
    tenders,
    selectedCategory,
    setSelectedCategory,
    isFetchingTenders,
    scrollCount,
    setScrollCount,
    fetchLimiter,

    // search filter
    categoryLists,
    setCategoryLists,
    regions,
    setRegions,
    language,
    setLanguage,
    SearchTenders,
    searchingTitle,
    setSearchingTitle,
    setSearchingRegionId,
    setSearchingLanguageId,
    setSearchingCategoryId,
    setSearchingSrc,
    searchParams,
    setSearchParams,

    tendersCategoryLists,
    setTendersCategoryLists,
    tendersRegions,
    setTendersRegions,
    tendersLanguage,
    setTendersLanguage,
    tendersSrc,
    setTendersSrc,
    feedCategoryLists,
    isFetchingFeedCategories,
    feedRegions,
    feedLanguage,
    getCategories,
    getLanguagesAndRegions,
    isFetchingLangAndReg,
    getSrc,
    isFetchingSrc,
    preferance,
    setPreferance,

    //
    searchIsClicked,
    setSearchIsClicked,
    selectedStatus,
    setSelectedStatus,

    // saved Alert
    savedCount,
    setSavedCount,

    //channels
    channels,
    setChannels,

    setTenders,
    // change page
    setApiPath,

    //bottom navigation
    clickedBtn,
    setClickedBtn,
    //tender detail
    showTenderDetail,
    setShowTenderDetail,
    prevRoute,
    setPrevRoute,
    scrollCoordinates,
    setScrollCoordinates,

    setShouldLoadTenders,

    //company details
    companyDetail,
    setCompanyDetail,

    //verify
    VerifyContact,
    verificationOtpIsSending,

    //subscription
    HandleSubscription,
    isFetchingInvoice,

    //telegram
    setTelegramApiPath,
    telegramTenderId,
    setTelegramTenderId,
    telegramUserNumber,
    setTelegramUserNumber,
  };

  return <context.Provider value={value}>{props.children}</context.Provider>;
};

export default TendersContextProvider;
